import React from 'react';
import agendaImage from '../assets/agenda-banner.jpg'; // Importa la imagen local

const AgendaBanner = () => {
    return (
        <div className="w-full mt-16 mb-8 relative rounded-3xl overflow-hidden shadow-xl group">
            {/* Blue Filter Overlays */}
            <div className="absolute inset-0 bg-primary-900/50 group-hover:bg-primary-800/40 transition-colors z-10" style={{ mixBlendMode: 'multiply' }}></div>
            <div className="absolute inset-0 bg-gradient-to-r from-blue-900/80 to-blue-600/60 z-10"></div>

            {/* Background Image */}
            <div
                className="absolute inset-0 bg-cover bg-center bg-no-repeat transform group-hover:scale-105 transition-transform duration-700"
                style={{ backgroundImage: `url(${agendaImage})` }}
            ></div>

            <div className="relative z-20 p-12 md:p-16 flex flex-col items-center justify-center text-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-6 drop-shadow-md tracking-tight">
                    AGENDA ACADÉMICA
                </h2>
                <p className="text-blue-100 text-lg md:text-xl max-w-2xl mb-8 drop-shadow">
                    Mantenete informado sobre los próximos cursos, charlas, jornadas y eventos institucionales del CALZ.
                </p>
                <a
                    href="https://calz.org.ar/agenda/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-8 py-4 bg-white text-primary-900 font-bold rounded-full shadow-lg hover:bg-slate-50 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 border-2 border-transparent hover:border-primary-100"
                >
                    Ver Agenda Completa
                </a>
            </div>
        </div>
    );
};

export default AgendaBanner;
